<template>
  <div>
    <v-card class="mx-auto mb-6" flat>
      <v-card-text>
        <v-alert dense text type="info" class="mt-3 mb-1 mx-3">
          <div class="black--text font-weight-medium">Informasi Pengisian:</div>
          <ol class="black--text" style="padding-inline-start: 20px">
            <li>
              Jika Anda mengetahui NUPTK sasaran atau pengajar. Silakan inputkan saja, sistem akan melakukan pencarian
              secara otomatis berdasarkan NUPTK tersebut
            </li>
            <li>
              Jika Anda tidak mengetahuin NUPTK nya. Maka inputkan data Nama, Jenis PTK dan Status Kepegawaian secara
              manual
            </li>
            <li>
              Jenis PTK misalnya adalah Guru Mapel, Guru Kelas, Kepala Sekolah, Wakil Kepala Sekolah, Tenaga
              Laboraratorium, dll
            </li>
            <li>
              Status Kepegawaian misalnya adalah Guru Honor Sekolah, PNS, Honor Daerah TK.I Provinsi, dll
            </li>
          </ol>
        </v-alert>
        <template v-for="(kategori, kategoriId) in kategoris">
          <div :key="kategoriId" class="my-5">
            <div class="mx-3">
              <strong style="font-size: 18px">{{ kategori.label }}</strong>
              <v-divider class="primary" style="height: 2.5px; max-height: 2.5px" />
            </div>
            <v-container>
              <v-list>
                <div v-for="(partisipan, id) in partisipans[kategori.key]" :key="id">
                  <v-list-item class="px-0">
                    <v-list-item-content class="py-0">
                      <v-row>
                        <v-col cols="12">
                          <div class="v-subheader theme--light px-0 body-2 grey--text" style="height: 24px;">
                            Memiliki NUPTK? <span class="red--text ml-1">*</span>
                          </div>
                          <v-radio-group
                            v-model="partisipans[kategori.key][id]['is_nuptk']"
                            :disabled="readOnly"
                            inline
                            row
                            class="my-0"
                            hide-details
                            @change="onChangePartisipan(kategori, id)"
                          >
                            <v-radio label="Ya" :value="1"></v-radio>
                            <v-radio label="Tidak" :value="0"></v-radio>
                          </v-radio-group>
                        </v-col>
                        <v-col cols="12" lg="3">
                          <div class="v-subheader theme--light px-0 body-2 grey--text" style="height: 24px;">
                            NUPTK <span class="red--text ml-1">*</span>
                          </div>
                          <validation-provider
                            v-if="partisipans[kategori.key][id]['is_nuptk']"
                            mode="passive"
                            :name="`NUPTK ${kategori.label} ke-${id + 1}`"
                            :rules="{ required: true }"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="partisipans[kategori.key][id]['nuptk']"
                              v-mask="`###################`"
                              placeholder="Tuliskan NUPTK"
                              outlined
                              dense
                              hide-details
                              :error-messages="errors"
                              :disabled="readOnly"
                              @input="onSearch(id, kategori.key)"
                            />
                          </validation-provider>
                          <div v-else class="black--text grey lighten-3 pa-2 py-3">-</div>
                        </v-col>
                        <v-col cols="12" lg="3">
                          <div class="v-subheader theme--light px-0 body-2 grey--text" style="height: 24px;">
                            Nama <span class="red--text ml-1">*</span>
                          </div>
                          <validation-provider
                            v-if="!partisipans[kategori.key][id]['is_nuptk']"
                            mode="passive"
                            :name="`Nama ${kategori.label} ke-${id + 1}`"
                            :rules="{ required: true }"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="partisipans[kategori.key][id]['nama']"
                              :placeholder="
                                partisipans[kategori.key][id]['nuptk'] !== '-'
                                  ? 'Tuliskan Nama'
                                  : `Nama ${kategori.label}`
                              "
                              :disabled="readOnly"
                              outlined
                              dense
                              hide-details
                              :error-messages="errors"
                            />
                          </validation-provider>
                          <div v-else class="black--text grey lighten-3 pa-2 py-3">
                            {{ partisipans[kategori.key][id]['nama'] || '-' }}
                          </div>
                        </v-col>
                        <v-col cols="12" lg="3">
                          <div class="v-subheader theme--light px-0 body-2 grey--text" style="height: 24px;">
                            Jenis PTK <span class="red--text ml-1">*</span>
                          </div>
                          <validation-provider
                            v-if="!partisipans[kategori.key][id]['is_nuptk']"
                            mode="passive"
                            :name="`Jenis PTK ${kategori.label} ke-${id + 1}`"
                            :rules="{ required: true }"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              v-model="partisipans[kategori.key][id]['k_jenis_ptk']"
                              :placeholder="
                                partisipans[kategori.key][id]['nuptk'] !== '-'
                                  ? 'Pilih Jenis PTK'
                                  : `Jenis PTK ${kategori.label}`
                              "
                              :disabled="readOnly"
                              outlined
                              dense
                              hide-details
                              :items="$mapForMaster((masters && masters.jenis_ptk) || {})"
                              :error-messages="errors"
                            />
                          </validation-provider>
                          <div v-else class="black--text grey lighten-3 pa-2 py-3">
                            {{
                              $getDeepObj(masters, `jenis_ptk.${partisipans[kategori.key][id]['k_jenis_ptk']}`) || '-'
                            }}
                          </div>
                        </v-col>
                        <v-col cols="12" lg="3">
                          <div class="v-subheader theme--light px-0 body-2 grey--text" style="height: 24px;">
                            Status Kepegawaian <span class="red--text ml-1">*</span>
                          </div>
                          <validation-provider
                            v-if="!partisipans[kategori.key][id]['is_nuptk']"
                            mode="passive"
                            :name="`Status Kepegawaian ${kategori.label} ke-${id + 1}`"
                            :rules="{ required: true }"
                            v-slot="{ errors }"
                          >
                            <v-autocomplete
                              v-model="partisipans[kategori.key][id]['k_pegawai']"
                              :placeholder="
                                partisipans[kategori.key][id]['nuptk'] !== '-'
                                  ? 'Pilih Status Kepegawaian'
                                  : `Status Kepegawaian ${kategori.label}`
                              "
                              :disabled="readOnly"
                              outlined
                              dense
                              hide-details
                              :items="$mapForMaster((masters && masters.pegawai) || {})"
                              :error-messages="errors"
                            />
                          </validation-provider>
                          <div v-else class="black--text grey lighten-3 pa-2 py-3">
                            {{ $getDeepObj(masters, `pegawai.${partisipans[kategori.key][id]['k_pegawai']}`) || '-' }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-list-item-action-text v-if="!readOnly && (partisipans[kategori.key] || []).length > 1">
                        <div class="v-subheader theme--light px-0 body-2 grey--text" style="height: 24px;">
                          &nbsp;
                        </div>
                        <v-btn
                          text
                          depressed
                          color="red"
                          class="mt-1 px-0"
                          style="min-width: 0"
                          @click="onDelPartisipan(kategori.key, id)"
                        >
                          <v-icon size="30">mdi-close</v-icon>
                        </v-btn>
                      </v-list-item-action-text>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider class="my-5" />
                </div>
                <div v-if="!readOnly">
                  <v-btn depressed color="primary" @click="onAddPartisipan(kategori.key === 'pengajar')">
                    <v-icon left>mdi-plus</v-icon> Tambah {{ kategori.label }}
                  </v-btn>
                </div>
              </v-list>
            </v-container>
          </div>
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'FormPartisipan',
  components: { ValidationProvider },
  props: {
    title: {
      type: String,
      default: '',
    },
    childId: {
      type: [String, Number],
      default: null,
    },
    initValue: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    masters: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      kategoris: [
        { key: 'sasaran', label: 'Sasaran IHT' },
        { key: 'pengajar', label: 'Pengajar IHT' },
      ],
      partisipans: {
        sasaran: [],
        pengajar: [],
      },
      debounce: { sasaran: null, pengajar: null },
    };
  },
  methods: {
    ...mapActions('iht', ['cekPartisipan']),

    reset() {
      this.$set(this.debounce, 'sasaran', null);
      this.$set(this.debounce, 'pengajar', null);
      this.$set(this.partisipans, 'sasaran', []);
      this.$set(this.partisipans, 'pengajar', []);

      const pspMonevPartisipan = this.$getDeepObj(this.initValue, 'psp_monev_partisipans') || [];

      for (const partisipan of pspMonevPartisipan) {
        this.addPartisipan(+partisipan.is_pengajar === 1, partisipan);
      }

      if (!this.partisipans.pengajar.length) {
        this.addPartisipan(true);
      }

      if (!this.partisipans.sasaran.length) {
        this.addPartisipan(false);
      }
    },

    onSearch(id, tipe) {
      const pspMonevId = this.$getDeepObj(this.initValue, 'psp_monev_id') || '';
      const keyword = this.partisipans[tipe][id]['nuptk'] || '';

      if (keyword.length < 12) return;

      clearTimeout(this.debounce && this.debounce[tipe]);
      this.debounce[tipe] = setTimeout(async () => {
        const params = { nuptk: keyword || '' };
        const data = await this.cekPartisipan({ id: pspMonevId, params });

        if (this.partisipans[tipe] && this.partisipans[tipe][id]) {
          const keys = ['nama', 'k_jenis_ptk', 'k_pegawai'];
          for (const key of keys) {
            this.$set(this.partisipans[tipe][id], key, data[key] || '');
          }
        }
      }, 600);
    },

    addPartisipan(isPengajar, data = {}) {
      const nuptk = data.nuptk || this.$getDeepObj(data, 'ptk.nuptk') || '';

      this.partisipans[isPengajar ? 'pengajar' : 'sasaran'].push({
        is_nuptk: nuptk ? 1 : 0,
        nuptk: nuptk || '',
        nama: data.nama || '',
        k_jenis_ptk: data.k_jenis_ptk || '',
        k_pegawai: data.k_pegawai || '',
      });
    },

    onAddPartisipan(isPengajar) {
      this.addPartisipan(isPengajar);
    },

    onDelPartisipan(kategori, id) {
      this.partisipans[kategori].splice(id, 1);
    },

    onChangePartisipan(kategori, id) {
      const keys = ['nuptk', 'nama', 'k_jenis_ptk', 'k_pegawai'];

      for (const key of keys) {
        this.partisipans[kategori.key][id][key] = '';
      }
    },

    getValue() {
      const sasarans = this.partisipans.sasaran.map((partisipan) => {
        return {
          is_pengajar: 0,
          nama: partisipan.nama,
          nuptk: partisipan.is_nuptk ? partisipan.nuptk : null,
          k_jenis_ptk: partisipan.k_jenis_ptk,
          k_pegawai: partisipan.k_pegawai,
        };
      });

      const pengajars = this.partisipans.pengajar.map((pengajar) => {
        return {
          is_pengajar: 1,
          nama: pengajar.nama,
          nuptk: pengajar.is_nuptk ? pengajar.nuptk : null,
          k_jenis_ptk: pengajar.k_jenis_ptk,
          k_pegawai: pengajar.k_pegawai,
        };
      });

      return [...[], ...sasarans, ...pengajars];
    },
  },
};
</script>

<style scoped></style>
